// HorecaConcurrent thema — basis interacties
document.addEventListener('DOMContentLoaded', function () {
  // Plek voor toekomstige interacties (bv. mobiel menu, snelle filters)
});
